<template>
  <div id="app">
    <HeaderView />
    <main>
      <router-view />
    </main>
    <FooterView />
  </div>
</template>

<script setup>
import HeaderView from './components/HeaderView.vue'
import FooterView from './components/FooterView.vue'
</script>

<style>
/* In App.vue <style> ergänzen: */

/* Reset und Box-sizing für alle Elemente */
*, *::before, *::after {
  box-sizing: border-box;
}

/* HTML und Body Overflow-Fix */
html, body {
  overflow-x: hidden;
  max-width: 100%;
  position: relative;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow-x: hidden; /* Zusätzlich hier */
}

main {
  flex: 1;
  width: 100%;
  overflow-x: hidden;
}
/* Touch-Event-Performance verbessern */
* {
  touch-action: manipulation;
}

iframe {
  touch-action: pan-x pan-y;
}

/* Passive Touch-Events global */
html {
  touch-action: manipulation;
}
/* Touch-Event-Performance verbessern */
* {
  touch-action: manipulation;
}

iframe {
  touch-action: pan-x pan-y;
}

/* Passive Touch-Events global */
html {
  touch-action: manipulation;
}
</style>